import { render } from "./GameSchedules.vue?vue&type=template&id=5dade1d8&scoped=true"
import script from "./GameSchedules.vue?vue&type=script&scoped=true&lang=js"
export * from "./GameSchedules.vue?vue&type=script&scoped=true&lang=js"

import "./GameSchedules.vue?vue&type=style&index=0&id=5dade1d8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dade1d8"]])

export default __exports__